module.exports = require("@tanstack/react-query");